import { render, staticRenderFns } from "./statistics-details.vue?vue&type=template&id=12d28ff7&scoped=true&"
import script from "./statistics-details.vue?vue&type=script&lang=js&"
export * from "./statistics-details.vue?vue&type=script&lang=js&"
import style0 from "./statistics-details.vue?vue&type=style&index=0&id=12d28ff7&lang=scss&scoped=true&"
import style1 from "./statistics-details.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d28ff7",
  null
  
)

export default component.exports